import { CheckboxButton } from 'element-ui'

const YCheckboxButton = CheckboxButton
YCheckboxButton.$depends = [CheckboxButton]
YCheckboxButton.$name = 'y-checkbox-button'
YCheckboxButton._name = 'CheckboxButton 复选框 按钮样式'

export default YCheckboxButton
